import React, { Component } from 'react'
import { Dispatch } from 'react-redux'
import { viewSmsPackage, toggleSmsPackage } from '~/services/api'
import { SmsPackageDTO } from '~/model'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import * as Status from '~/helper/constant/status'
import * as route from '~/helper/constant/route'
import { toastMessage } from '~/helper/function/util'
import $ from 'jquery'

type Props = {
    token: String,
    dispatch: Dispatch<any>,
}

type State = {
    data: Array,
    smsPackages: Array,
    loading: Boolean,
}

export class AbstractSmsPackageViewComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            smsPackages: [
                {
                    code: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    name: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    sms_limit: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    currency: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    price: {
                        field: 'text',
                        route: false,
                        sortable: true,
                    },
                    status: {
                        field: 'badge',
                        modal: true,
                        sortable: true,
                    },
                    action: {
                        field: 'button',
                        route: true,
                        sortable: false,
                    },
                },
            ],
        }
        this._handleChange = this._handleChange.bind(this)
        this.toggle = this.toggle.bind(this)
    }

    componentDidMount() {
        this.loadSmsPackages()
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    toggle(id) {
        toggleSmsPackage(id, this.props.token).then((response) => {
            if (response.code == API_SUCCESS) {
                toastMessage('success', response.message)
                this.loadSmsPackages()
            } else {
                toastMessage('error', response.message)
            }
        })
    }

    loadSmsPackages() {
        this._handleChange('loading', true)
        viewSmsPackage(this.props.token).then((response) => {
            this._handleChange('loading', false)
            let smsPackages = []
            smsPackages.push(this.state.smsPackages[0])
            let dataList = []
            if (response.code == API_SUCCESS) {
                response.data.sms_package.map((item, index) => {
                    const data: SmsPackageDTO = item
                    let text = null
                    if (data.status == Status.ACTIVE) {
                        text = {
                            text: 'Active',
                            badge: 'table-green',
                            modal: 'modal_sms_package_' + index,
                        }
                    } else {
                        text = {
                            text: 'Inactive',
                            badge: 'table-red',
                            modal: 'modal_sms_package_' + index,
                        }
                    }
                    const tableData = {
                        code: {
                            text: data.code,
                        },
                        name: {
                            text: data.name,
                        },
                        sms_limit: {
                            text: data.limit,
                        },
                        currency: {
                            text: data.currency,
                        },
                        price: {
                            text: data.rate,
                        },
                        status: text,
                        action: {
                            text: 'Edit',
                            route: route.superadmin.sms_package.edit + '/' + data.id,
                        },
                    }
                    dataList.push(data)
                    smsPackages.push(tableData)
                })
            }
            this.setState({
                data: dataList,
                smsPackages,
            })
        })
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
    }
}
